import React from 'react';

interface KlavtorgConfigurationProps {
    configuration: {
        Login?: string;
        Password?: string;
        Warehouses?: string;
    };
    onChange: (field: string, value: string | number | unknown) => void;
    disabled?: boolean;
}

interface KlavtorgConfigurationComponent extends React.FC<KlavtorgConfigurationProps> {
    configFields: string[];
}

const KlavtorgConfiguration: KlavtorgConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">👤</span>
                    Логин
                </label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={configuration.Login || ''}
                        onChange={(e) => onChange('Login', e.target.value)}
                        placeholder="Введите логин"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🔒</span>
                    Пароль
                </label>
                <div className="input-group-custom">
                    <input
                        type="password"
                        className="form-input-custom"
                        value={configuration.Password || ''}
                        onChange={(e) => onChange('Password', e.target.value)}
                        placeholder="Введите пароль"
                        disabled={disabled}
                        autoComplete='new-password'
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
KlavtorgConfiguration.configFields = ['Login', 'Password'];

export default KlavtorgConfiguration;
